import { TENANTS,USERS } from './../../../shared/services/firestore/constants/DbNameConstants';
import {
    signInWithEmailAndPassword,
    getAuth,
    createUserWithEmailAndPassword
} from "firebase/auth";
import { FirebaseApp, FirestoreDb } from "../../../shared/services/firestore/firestore";
import { addDoc, setDoc, collection, doc } from "firebase/firestore";

export const auth = getAuth(FirebaseApp);

export const logInWithEmailAndPassword = async (email, password) => {
    try {
        return await signInWithEmailAndPassword(auth, email, password);
    } catch (err) {
        console.error(err);
    }
};

export const registerWithEmailAndPassword = async (email, password) => {
    try {
        const res = await createUserWithEmailAndPassword(auth, email, password);
        const user = res.user;

        // Create tenant
        const newTenantRef = doc(collection(FirestoreDb, "tenants"));
        await setDoc(doc(FirestoreDb, TENANTS, newTenantRef.id), {
            userId: user.uid,
            tenantId: newTenantRef.id,
            email,
        });
        // Create User
        await setDoc(doc(FirestoreDb, USERS, user.uid), {
            userId: user.uid,
            email,
            tenantId: newTenantRef.id,
        });

        return newTenantRef.id;
    } catch (err: any ) {
        console.error(err);
        alert(err.message);
    }
};
